import { Button } from '@/components/atoms/NewPcButton';
import React from 'react';
import KaKaoIcon from '@/assets/icons/More/payment_icon_yellow_large 1.svg?react';

import useCheckMembership from '@/hooks/useCheckMembership';
import { useAppSelector } from '@/redux/store';
import { Dialog, DialogTrigger, DialogContent } from '@/components/atoms/Dialog';
import { useState } from 'react';

import NewPaymentDialog from '@/containers/payment/NewPaymentDialog';
import { CPLAT_API_ROUTES, usePost } from '@/api';
import { useEffect } from 'react';

import MembershipFailDialog from '@/containers/payment/MembershipFailDialog';
import { useSearchParams } from 'react-router-dom';
import { useToast } from '@/hooks/V3/useToast';
import AlertDialog from '@/components/dashboard/alert-dialog';

const PcMembership = () => {
  const isMember = useCheckMembership();
  const ServiceInfo = useAppSelector((state: any) => state.user.ServiceInfo);
  const [searchParams, setSearchParams] = useSearchParams();
  const user = useAppSelector((state) => state.user);
  const [billDialogOpen, setBillDialogOpen] = useState<boolean>(false);
  const paymentAmount = 15000; // 결제 금액 (15,000원)
  const [isFailOpen, setIsFailOpen] = useState<boolean>(false);

  const { showToast } = useToast();

  const { mutate: getUserInfo } = usePost(CPLAT_API_ROUTES.getUserInfo);

  useEffect(() => {
    const result = searchParams.get('result');
    const paymentChange = searchParams.get('paymentChange') === 'true';

    if (result === 'success') {
      getUserInfo({ cplatToken: user.CplatToken });

      // 성공 시 토스트만 띄움
      showToast(
        'congratulations',
        paymentChange
          ? '멤버십 결제 수단 변경이 완료되었어요!'
          : '멤버십 구독이 완료되었어요! 지금 바로 셀러박스 플러스 기능을 이용해 보세요.',
      );
    }
    if (result === 'fail') {
      setIsFailOpen(true); // 실패 시 다이얼로그
    }

    // 파라미터 제거
    if (result) {
      searchParams.delete('result');
      searchParams.delete('paymentChange');
      setSearchParams(searchParams, { replace: true });
    }
  }, [searchParams, setSearchParams, showToast]);

  // 다이얼로그 오픈 시 getUserInfo 호출
  useEffect(() => {
    if (isFailOpen) {
      getUserInfo({ cplatToken: user.CplatToken });
    }
  }, [isFailOpen, getUserInfo, user.CplatToken]);

  // 무료 체험 여부를 확인하기 위한상태

  const isAnySubscribed = ServiceInfo.AppSellerInfo.IsAnySubscribed;
  const subscriptionNo = isAnySubscribed ? 23 : 22; // 무료 체험 대상 즉 isAnySubscribed가 false인지 확인 22, 아니면 23

  return (
    <div className="relative flex h-full w-full flex-1 flex-col gap-[16px] overflow-y-auto">
      <AlertDialog />
      <div className="mx-auto flex h-full w-full max-w-[1680px] flex-1 flex-col gap-[16px] p-[40px]">
        <div className="flex h-full w-full flex-col gap-[16px]">
          <div className="text-gr-900 Title2S24">멤버십</div>
          <div className="flex h-full w-full flex-col rounded-[16px] border bg-white p-5">
            <div className="flex w-full justify-between">
              <div className="flex flex-col gap-[11px]">
                <div className="text-gr-8000 Title3S18">
                  {!isAnySubscribed
                    ? '셀러박스 플러스 기능들을 14일동안 무료로 체험해 보세요!'
                    : '셀러박스 멤버십을 구독하고 다양한 기능들을 이용해 보세요!'}
                </div>
                <div className="flex gap-[6px] text-gr-700 Body5M14">
                  <div>1개월</div>

                  <div>·</div>
                  <div>{paymentAmount.toLocaleString('ko-KR')}원</div>
                  <div>·</div>
                  <div>VAT 포함</div>
                </div>
              </div>
              <div>
                {isMember ? (
                  <Button className="w-[280px]  rounded-[8px] py-[11px] text-white Body5M14">
                    구독중
                  </Button>
                ) : (
                  <Dialog open={billDialogOpen} onOpenChange={setBillDialogOpen}>
                    <DialogTrigger asChild>
                      <Button className="w-[280px]  rounded-[8px] py-[11px] text-white Body5M14">
                        지금 구독하기
                      </Button>
                    </DialogTrigger>
                    <NewPaymentDialog
                      isPrePayment={false}
                      subscriptionNo={subscriptionNo}
                      paymentAmount={paymentAmount}
                      setBillDialogOpen={setBillDialogOpen}
                    />
                  </Dialog>
                )}
              </div>
            </div>
            <div>
              <table className="mt-8 w-full  text-center">
                <thead className="border-b-2 border-gr-700">
                  <tr className="">
                    <th className=" pb-[16px] text-left text-gr-800 Body4S14">기능</th>
                    <th className="pb-[16px] text-center text-gr-800 Body4S14 ">무료</th>
                    <th className="pb-[16px] text-center text-point-500 Body4S14 ">멤버십</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b">
                    <td className=" py-4 text-left text-gr-700 Body5M14">마켓 연동</td>
                    <td className=" py-4 text-center text-gr-700 Body5M14 ">무제한</td>
                    <td className=" py-4 text-center text-point-500 Body5M14 ">무제한</td>
                  </tr>
                  <tr className="border-b">
                    <td className=" py-4 text-left text-gr-700 Body5M14 ">
                      주문, 정산, 배송, 리뷰 데이터 통합 조회
                    </td>
                    <td className=" py-4 text-center text-gr-700 Body5M14 ">O</td>
                    <td className=" py-4 text-center text-point-500 Body5M14 ">O</td>
                  </tr>
                  <tr className="border-b">
                    <td className=" py-4 text-left text-gr-700 Body5M14 ">
                      주문, 정산, 배송, 리뷰 데이터 수집 및 알림
                    </td>
                    <td className=" py-4 text-center text-gr-700 Body5M14 ">30분 간격</td>
                    <td className=" py-4 text-center text-point-500 Body5M14 ">10분 간격</td>
                  </tr>
                  <tr className="border-b">
                    <td className=" py-4 text-left text-gr-700 Body5M14 ">
                      상품 발송 처리 (주문확인, 송장입력)
                    </td>
                    <td className=" py-4 text-center text-gr-700 Body5M14 ">X</td>
                    <td className=" py-4 text-center text-point-500 Body5M14 ">O</td>
                  </tr>
                  <tr className="border-b">
                    <td className=" py-4 text-left text-gr-700 Body5M14 ">
                      문의 답변 기능 (AI 답변 생성)
                    </td>
                    <td className=" py-4 text-center text-gr-700 Body5M14 ">X</td>
                    <td className=" py-4 text-center text-point-500 Body5M14 ">O</td>
                  </tr>
                  <tr className="border-b">
                    <td className=" py-4 text-left text-gr-700 Body5M14 ">AI 리뷰 답변 생성</td>
                    <td className=" py-4 text-center text-gr-700 Body5M14 ">하루 3회</td>
                    <td className=" py-4 text-center text-point-500 Body5M14 ">무제한</td>
                  </tr>
                  <tr className="border-b">
                    <td className=" py-4 text-left text-gr-700 Body5M14 ">상품 모니터링</td>
                    <td className=" py-4 text-center text-gr-700 Body5M14 ">1개</td>
                    <td className=" py-4 text-center text-point-500 Body5M14 ">10개</td>
                  </tr>
                  <tr className="border-b border-gr-700">
                    <td className=" py-4 text-left text-gr-700 Body5M14 ">키워드 분석</td>
                    <td className=" py-4 text-center text-gr-700 Body5M14 ">X</td>
                    <td className=" py-4 text-center text-point-500 Body5M14 ">O</td>
                  </tr>
                </tbody>
              </table>
              <div className="w-fit rounded-[20px] bg-white ">
                <div className="mb-[8px] mt-[20px] text-gr-700 Body4S14">확인해 주세요!</div>
                <ul className="list-disc pl-[26px] text-gr-600 Body5M14">
                  <li>멤버십 결제 회원의 CS를 최우선으로 응대 합니다.</li>
                  <li>
                    리뷰 기능 지원 마켓은 지속적으로 추가중에 있으며, 현재 지원하는 다음과 같습니다.
                  </li>
                  <li className="ml-[26px]">
                    스마트스토어, 카페24, 아임웹, 샵바이, 에이블리, 아이디어스, 지그재그, 식스샵,
                    올웨이즈, 인터파크
                  </li>
                  <li>
                    상품 모니터링 기능 지원 마켓은 지속적으로 추가중에 있으며, 현재 지원하는 마켓은
                    다음과 같습니다.
                  </li>
                  <li className="ml-[26px]">스마트스토어</li>
                  <li>
                    실험실 - 상품진단 기능 지원 마켓은 지속적으로 추가중에 있으며, 현재 지원하는
                    마켓은 다음과 같습니다.
                  </li>
                  <li className="ml-[26px]">스마트스토어</li>
                  <li>
                    상품 발송 기능 지원 마켓은 지속적으로 추가중에 있으며, 현재 지원하는 마켓은
                    다음과 같습니다.
                  </li>
                  <li className="ml-[26px]">
                    스마트스토어, 쿠팡, 11번가, 지마켓, 옥션, 롯데온, 톡스토어, 카페24, 샵바이,
                    아임웹
                  </li>
                  <li>
                    문의 기능 지원 마켓은 지속적으로 추가중에 있으며, 현재 지원하는 마켓은 다음과
                    같습니다.
                  </li>
                  <li className="ml-[26px]">
                    스마트스토어, 쿠팡, 11번가, 지마켓, 옥션, 롯데온, 톡스토어, 카페24, 샵바이
                  </li>
                </ul>
                <div className="Body5S14 mb-[8px] mt-[12px] text-gr-700">멤버십 결제 유의사항</div>
                <ul className="Body6M14 list-disc pl-[26px] text-gr-600">
                  <li>
                    14일 무료체험 종료 시 멤버십 자동 결제가 진행되며, 자동 결제 진행 2일 전 앱 푸시
                    메시지로 알려드립니다.
                  </li>
                  <li>멤버십 가격은 부가세와 결제수수료가 포함되어 있습니다.</li>
                  <li>
                    등록하신 결제 수단으로 매월 정기 결제일에 멤버십 이용 금액이 자동으로
                    결제됩니다.
                  </li>
                  <li>
                    멤버십은 언제든 해지할 수 있으며 해지 이후에도 결제 만료일 까지 사용 가능합니다.
                  </li>
                  <li>
                    멤버십 사용 중에는 남은 기간에 대한 금액은 별도의 환불이 진행되지 않습니다.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <MembershipFailDialog open={isFailOpen} setOpen={setIsFailOpen} />
    </div>
  );
};

export default PcMembership;
